
import FIcon from '@/components/atoms/icons/h-icon';

export default {
  name: 'ExpansionPanels',

  components: {
    FIcon,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    mobileOnlyTitle: {
      type: Boolean,
    },
    content: {
      type: [Array, Object],
      required: true,
    },
    eager: {
      type: Boolean,
    },
  },

  computed: {
    panel() {
      if (typeof this.content.map === 'undefined') {
        return [];
      }
      return this.content.map((_e, i) => i);
    },
  },

  methods: {
    stripParagraphs(titleHtml = '') {
      return titleHtml.replace('<p>', '').replace('</p>', '');
    },
  },
};
